import api from "../index"

const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (params) => ({
        url: `/auth/login`,
        method: "POST",
        body: params,
      }),
    }),
    verifyLoginOTP: build.mutation({
      query: (params) => ({
        url: `/auth/verify/otp`,
        method: "POST",
        body: params,
      }),
    }),
    resendOTP: build.mutation({
      query: (params) => ({
        url: `/auth/resend/otp`,
        method: "POST",
        body: params,
      }),
    }),
    forgotPassword: build.mutation({
      query: (params) => ({
        url: `/auth/forgot-password`,
        method: "POST",
        body: params,
      }),
    }),
    resetPassword: build.mutation({
      query: (params) => ({
        url: `/auth/reset-password`,
        method: "POST",
        body: params,
      }),
    }),

    AdminResetPassword: build.mutation({
      query: (params) => ({
        url: `/public/admin/reset-password`,
        method: "POST",
        body: params,
      }),
    }),
  }),
})

export const {
  useLoginMutation,
  useVerifyLoginOTPMutation,
  useResendOTPMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useAdminResetPasswordMutation,
} = userApi
